import api from '@src/api/axiosInstance';
import {readLoadingCache,writeLoadingCache,loadingCacheGeneration} from '@src/helpers/LoadingCache';
import {beginOutgoing,updateOutgoing} from '@src/helpers/OutgoingDisplay';
import { ApiResponse, PaginatedResponse } from '@src/types/common';
import {
	CreateMessageRequest,
	CreateMessageResponse,
	FetchMessagesRequest,
	MarkAsReceivedRequest,
	Message,
} from '@src/types/messages';

export const cachedMessages = (waId:string) => {
 const page=readLoadingCache<PaginatedResponse<Message>>('messages:'+waId,120000);
 // Call recordings have additional live privacy checks; never replay them
 // from the browser cache before the current message response authorizes them.
 return page?.results.some(m=>m.waba_payload?.type==='call') ? undefined : page;
};
export const fetchMessages = async (
	params: FetchMessagesRequest,
	signal?: AbortSignal
) => {
 const generation=loadingCacheGeneration();
	const response = await api.get<PaginatedResponse<Message>>('/messages/', {
		params,
		signal,
	});
 if(generation===loadingCacheGeneration() && !signal?.aborted && !params.before_time && !params.since_time && !params.offset && params.limit===30)writeLoadingCache('messages:'+params.wa_id,response.data);
	return response.data;
};

export const createMessage = async (data: CreateMessageRequest) => {
	data.pending_message_unique_id ||= crypto.randomUUID();
	beginOutgoing(data);
	const response = await api.post<CreateMessageResponse>('/messages/', data).catch(error => {
		updateOutgoing(data.pending_message_unique_id!,{state:!error.response || error.response.status>=500 || error.response.status===409?'uncertain':'failed'});
		window.displayCustomError(error.response?.data?.detail || 'No se ha podido confirmar el envío. Comprueba la conversación antes de repetirlo.');
		throw error;
	});
	updateOutgoing(data.pending_message_unique_id!,{state:'accepted',serverId:response.data.id});
	return {
		status: response.status,
		data: response.data,
	} as ApiResponse<CreateMessageResponse>;
};

export const markAsReceived = async (
	data: MarkAsReceivedRequest,
	signal?: AbortSignal
) => {
	return await api.post('/mark_as_received/', data, { signal });
};
